export const caseWorkerSelector = ({ activeIds, entities }) => (
  entities.loanForgiveness.byId[activeIds.forgivenessId]?.caseWorker
);
